import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login/Login';
import Main from '@/views/Main';
import subjectList from '@/views/resourceManagement/subjectList';
import subjectAdd from '@/views/resourceManagement/subjectAdd';
import subjectEdit from '@/views/resourceManagement/subjectEdit';
import resourceIndex from '@/views/resourceIndex/resourceIndex';
import resourceList from '@/views/resourceManagement/resourceList';
import resourceAdd from '@/views/resourceManagement/resourceAdd';
import resourceEdit from '@/views/resourceManagement/resourceEdit';
import resourceDetail from '@/views/resourceManagement/resourceDetail';
import resourceCommentList from '@/views/resourceManagement/resourceCommentList';
import accountingSidebar from '@/views/accounting/accountingSidebar';
import dataAccounting from '@/views/accounting/dataAccounting';
import videoAccounting from '@/views/accounting/videoAccounting';
import videoSchoolAccounting from '@/views/accounting/videoSchoolAccounting';
import videoGradeAccounting from '@/views/accounting/videoGradeAccounting';
import videoNotWatchList from '@/views/accounting/videoNotWatchList';
import videoWatchList from '@/views/accounting/videoWatchList';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        }, {
            path: '/login',
            name: 'login',
            component: Login
        }, {
            path: '/main',
            name: 'main',
            component: Main,
            children: [{
                path: '',
                redirect: 'resourceIndex'
            }, {
                path: 'resourceIndex',
                name: 'resourceIndex',
                component: resourceIndex
            }, {
                path: 'resourceDetail',
                name: 'userResourceDetail',
                component: resourceDetail
            }, {
                path: 'resourceCommentList',
                name: 'resourceCommentList',
                component: resourceCommentList
            }, {
                path: 'resourceManagement',
                name: 'resourceManagement',
                component: subjectList,
                meta: {
                    permissionPath: '/videoResourcePlatform/videoResourcePlatformAdmin'
                }
            }, {
                path: 'resourceManagement/subjectAdd',
                name: 'subjectAdd',
                component: subjectAdd,
                meta: {
                    permissionPath: '/videoResourcePlatform/videoResourcePlatformAdmin'
                }
            }, {
                path: 'resourceManagement/subjectEdit',
                name: 'subjectEdit',
                component: subjectEdit,
                meta: {
                    permissionPath: '/videoResourcePlatform/videoResourcePlatformAdmin'
                }
            }, {
                path: 'resourceManagement/resourceList',
                name: 'resourceList',
                component: resourceList,
                meta: {
                    permissionPath: '/videoResourcePlatform/videoResourcePlatformAdmin'
                }
            }, {
                path: 'resourceManagement/resourceAdd',
                name: 'resourceAdd',
                component: resourceAdd,
                meta: {
                    permissionPath: '/videoResourcePlatform/videoResourcePlatformAdmin'
                }
            }, {
                path: 'resourceManagement/resourceEdit',
                name: 'resourceEdit',
                component: resourceEdit,
                meta: {
                    permissionPath: '/videoResourcePlatform/videoResourcePlatformAdmin'
                }
            }, {
                path: 'resourceManagement/resourceDetail',
                name: 'resourceDetail',
                component: resourceDetail,
                meta: {
                    permissionPath: '/videoResourcePlatform/videoResourcePlatformAdmin'
                }
            }, {
                path: 'accounting',
                name: 'accounting',
                component: accountingSidebar,
                children: [{
                    path: '',
                    redirect: 'dataAccounting',
                    meta: {
                        permissionPath: '/videoResourcePlatform/videoResourcePlatformAccountant'
                    }
                }, {
                    path: 'dataAccounting',
                    name: 'dataAccounting',
                    component: dataAccounting,
                    meta: {
                        permissionPath: '/videoResourcePlatform/videoResourcePlatformAccountant'
                    }
                }, {
                    path: 'videoAccounting',
                    name: 'videoAccounting',
                    component: videoAccounting,
                    meta: {
                        permissionPath: '/videoResourcePlatform/videoResourcePlatformAccountant'
                    }
                }, {
                    path: 'videoSchoolAccounting',
                    name: 'videoSchoolAccounting',
                    component: videoSchoolAccounting,
                    meta: {
                        permissionPath: '/videoResourcePlatform/videoResourcePlatformAccountant'
                    }
                }, {
                    path: 'videoGradeAccounting',
                    name: 'videoGradeAccounting',
                    component: videoGradeAccounting,
                    meta: {
                        permissionPath: '/videoResourcePlatform/videoResourcePlatformAccountant'
                    }
                }, {
                    path: 'videoNotWatchList',
                    name: 'videoNotWatchList',
                    component: videoNotWatchList,
                    meta: {
                        permissionPath: '/videoResourcePlatform/videoResourcePlatformAccountant'
                    }
                }, {
                    path: 'videoWatchList',
                    name: 'videoWatchList',
                    component: videoWatchList,
                    meta: {
                        permissionPath: '/videoResourcePlatform/videoResourcePlatformAccountant'
                    }
                }]
            },
            {
                path:'schoolAccount',
                name:'schoolAccount',
                component:()=>import('@/views/schoolAccount/schoolAccountIndex'),
                children:[
                    {
                        path:'/',
                        redirect:'videoAccounting'
                    },{
                        path:'videoAccounting',
                        name:'videoAccounting',
                        component:()=>import('@/views/schoolAccount/videoAccounting'),
                        meta: {
                            permissionPath: '/videoResourcePlatform/schoolResourceForAccount'
                        }

                    },{
                        path: 'videoSchoolAccounting',
                        name: 'videoSchoolAccounting',
                        component: ()=>import('@/views/schoolAccount/videoSchoolAccounting'),
                        meta: {
                            permissionPath: '/videoResourcePlatform/schoolResourceForAccount'
                        }

                    },{
                        path: 'videoNotWatchList',
                        name: 'videoNotWatchList',
                        component: ()=>import('@/views/schoolAccount/videoNotWatchList'),
                        meta: {
                            permissionPath: '/videoResourcePlatform/schoolResourceForAccount'
                        }

                    }, {
                        path: 'videoWatchList',
                        name: 'videoWatchList',
                        component: ()=>import('@/views/schoolAccount/videoWatchList'),
                        meta: {
                            permissionPath: '/videoResourcePlatform/schoolResourceForAccount'
                        }

                    }
                ]
            },{
                path:'system',
                name:'system',
                component:()=>import('@/views/systemManage/index'),
                children:[
                    {
                        path:'/',
                        redirect:'educationList'
                    },
                    {
                        path:'educationList',
                        name:'educationList',
                        component:()=>import('@/views/systemManage/educationList')
                    },
                    {
                        path:'addEducation',
                        name:'addEducation',
                        component:()=>import('@/views/systemManage/addEducation')
                    },
                    {
                        path:'editEducation',
                        name:'editEducation',
                        component:()=>import('@/views/systemManage/editEducation')
                    },
                    {
                        path:'educationCountList',
                        name:'educationCountList',
                        component:()=>import('@/views/systemManage/educationCountList')
                    },
                    {
                        path:'addEducationCount',
                        name:'addEducationCount',
                        component:()=>import('@/views/systemManage/addEducationCount')
                    },
                    {
                        path:'editEducationCount',
                        name:'editEducationCount',
                        component:()=>import('@/views/systemManage/editEducationCount')
                    }
                ]
            }]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js